import React from "react"
import { Link } from "react-router-dom"
import { formatDistanceToNow } from "date-fns"
import { TextAsImage } from "./TextAsImage"
import { ShareUrlButton } from "../ShareUrlButton"
import { useNavigateToPost } from "@hooks/useNavigateToPost"
import ConcertMediaScreen from "@components/comments/ConcertMediaScreen"
import CommentSectionPreview from "@components/comments/CommentSectionPreview"

interface PostCommentsListItemProps {
  post: any
}

const PostCommentsListItem = ({ post }: PostCommentsListItemProps) => {
  const navigateToPost = useNavigateToPost(post.nada_path)
  const hasMedia =
    post.attached_media?.length > 0 || post.cover_image_url_medium
  const eventAgo = post.published_at
    ? formatDistanceToNow(new Date(post.published_at), { addSuffix: true })
    : null

  return (
    <div className="grid grid-cols-12">
      <div className="lg:col-span-7 col-span-12">
        {hasMedia ? (
          <ConcertMediaScreen
            postId={post.id}
            coverImageUrl={post.cover_image_url_medium ?? null}
            attachedMedia={post.attached_media || []}
            showHeader={false}
            coverMode={true}
            className=""
          />
        ) : (
          <button
            className="cursor-pointer w-full aspect-video"
            onClick={navigateToPost}
          >
            <TextAsImage text={post.title} />
          </button>
        )}
      </div>

      <div className="lg:col-span-5 col-span-12 lg:pl-4 pt-2 lg:pt-0">
        <h2
          className="lg:text-xl text-base font-bold text-black-800 pb-2 leading-none cursor-pointer"
          onClick={navigateToPost}
        >
          <span dangerouslySetInnerHTML={{ __html: post.title }} />{" "}
          <ShareUrlButton nadaUrl={post.nada_url} renderMode="icon" />
        </h2>

        {eventAgo && (
          <div className="text-xs md:text-sm text-black-800 leading-none md:leading-normal">
            New Comments on Event from {eventAgo}
          </div>
        )}

        <Link
          to={post.local_path}
          className="text-xs text-gray-500 italic leading-none"
        >
          Posted by {post.band_name}
        </Link>

        <CommentSectionPreview
          postId={post.id}
          postPath={post.nada_url}
          mode="preview"
          perPage={5}
          className="mt-3"
        />
      </div>
    </div>
  )
}

export default PostCommentsListItem
